module.exports = __webpack_public_path__ + "img/5.233b72ab.png";